import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../auth/auth.service';
import { ToasterService } from '../../providers/toaster/toaster.service';
import { catchError, Observable, switchMap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DepartmentApiServiceService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  getDepartmentList(page?: number,search?: string): Observable<any> {
    let queryParams = new HttpParams();

    if (page) {
      queryParams = queryParams.set('page', page);
    }if (search) {
      queryParams = queryParams.set('search', search);
    }
    return this.http.get(`${this.apiUrl}department/get-all`,{ params: queryParams });
  }

  addDepartment(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}department/create`, data);
  }

  updateDepartment(data: any, id: any): Observable<any> {
    return this.http.post(`${this.apiUrl}department/update/${id}`, data);
  }

  deleteDepartment(id: any): Observable<any> {
    return this.http.get(`${this.apiUrl}department/delete/${id}`);
  }

}
